const prependHttp = (url: string) => {
    if (!/^https?:\/\//i.test(url)) {
        url = new Request("//" + url).url;
    }
    return url;
};

export default prependHttp;
